import React, { useEffect, useState } from "react";
import BlogSmallCard from "../components/common/card/BlogSmallCard";
import BlogContent from "../components/layout/BlogContent";
import ProductsFromModel from "../components/common/products/ProductsFromModel";
import BlogCardImage from "../components/common/card/BlogCardImage";
import { httpReauest } from "../utils/httpRequest";
import { Link, useParams } from "react-router-dom";
import { CDN_BASE_URL } from "../config";
import Loading from "../components/common/Loading";
import { Helmet } from "react-helmet";
import BlogsRelated from "../components/common/mobile/BlogsRelated";
import CommentsBlog from "../components/common/mobile/CommentsBlog";
import CommentsBlogDesktop from "../components/common/mobile/CommentsBlogDesktop";
import CommentFormMobileBlog from "../components/common/mobile/CommentFormMobileBlog";

const BlogsDetail = () => {
  const { name } = useParams();

  const [data, setData] = useState();
  const [loading, setloading] = useState();
  const [blogs, setBlogs] = useState();
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    getData();
  }, [name]);

  async function getData() {
    setloading(true);
    await httpReauest("GET", "/blog/" + name, {}, {}).then(async ({ data }) => {
      setData(data?.data);
      await httpReauest(
        "GET",
        `/vehicle${
          data?.data?.related ? "?category=" + data?.data?.related : ""
        }`,
        {},
        {}
      ).then(({ data }) => {
        setVehicles(data.data);
      });
    });
    await httpReauest("GET", "/blog?limit=16", {}, {}).then(({ data }) => {
      setBlogs(data?.data);
    });
    setloading(false);
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="container_1 py-8">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"1924 - " + data?.name}</title>
        <meta name="description" content={data?.meta_desc} />
        <meta name="keywords" content={data?.meta_keywords} />
        <meta name="og:description" content={data?.meta_desc} />
        <meta name="og:title" content={data?.name} />
        <meta name="author" content={data?.author} />
      </Helmet>{" "}
      <img
        src={CDN_BASE_URL + data?.cover}
        className="w-full  object-cover my-10 rounded-[10px] center"
        alt=""
      />
      <div className="py-1 text-center">
        <h1 className="title">{data?.name}</h1>
      </div>
      <div className="my-12">
        <p className="desc">{data?.desc}</p>
      </div>
      <div className="grid grid-cols-3 my-12 gap-6">
        <span className="col-span-2 grid ">
          <BlogContent data={data?.content} />
          <span className="mt-12">
            {data?._id && <CommentFormMobileBlog blog={data?._id} />}
          </span>
          <span className="mt-8">
            {data?._id && <CommentsBlogDesktop blog={data?._id} />}
          </span>
        </span>
        <span className="flex flex-col h-full">
          <span className="border-brand px-2 py-4 w-full sticky top-[110px]">
            <h2 className="font-bold text-[22px]">
              آخرین مطالب اخبار و دانستنی ها
            </h2>
            {blogs?.slice(0, 4)?.map((e) => (
              <BlogSmallCard data={e} />
            ))}
          </span>
        </span>
      </div>
      <div className="my-12">
        {vehicles && (
          <ProductsFromModel data={vehicles} title={"محصولات مرتبط"} />
        )}
      </div>
      <div>
        <h3 className="title">مقالات مرتبط</h3>
        <div className="grid grid-cols-3 xl:grid-cols-4 gap-5 mt-4">
          <BlogsRelated related={data?.related} />
        </div>
      </div>
    </div>
  );
};

export default BlogsDetail;
